<template>
  <div class="over">
    <!-- Wrapper -->
    <div id="temps" class="details-wrapper noselect" :class="{ large: this.getSensorType === 'accelerometer' }">
      <div class="infoi" v-show="!this.getLoadingStatus || !this.getIsThereData">
        <h2 v-if="!this.getIsThereData && this.getLoadingStatus">{{ $t("message.noDataInRange") }}...</h2>
        <h2 v-else>{{ $t("message.loading") }}...</h2>
      </div>
      <!-- Video Tutorial -->
      <transition name="settings">
        <ModalVideoTutorial @close-me="showVideoTutorial = false" v-if="showVideoTutorial" :video="'tiltmeter'" />
      </transition>
      <!-- Titolo del Modulo -->
      <div class="main-wrap over-info">
        <h2 v-if="this.getSensorType === 'deck'">Time Response</h2>
        <h2 v-if="this.getSensorType === 'tiltmeter'">{{ $t("dataType.tilts") }}</h2>
        <img v-if="this.getSensorType === 'tiltmeter'" class="info-svg" @click="showVideoTutorial = true" src="../../../../public/assets/icons/info.svg" alt />
        <h2 v-if="this.getSensorType === 'crackmeter'">{{ $t("dataType.extensions") }}</h2>
        <h2 v-if="this.getSensorType === 'accelerometer'">{{ $t("dataType.accelerations") }}</h2>
        <p class="first-block">{{ $t("message.dataOfSelectedDevice") }}</p>
        <img @click="downloadEventDetails" class="download-btn" src="../../../../public/assets/download.svg" v-if="this.getSensorType === 'deck' || this.getSensorType === 'accelerometer' " />
      </div>
      <!-- Deck -->
      <LinePlot
        v-if="this.getDispDetails && this.getSensorType === 'deck'"
        :height="this.plotHeight"
        :traces="this.getDispTrace"
        yTitle="Displacement (mm)"
        xTitle="Time (s)"
        :xRange="[this.getDisplacementBegin(this.getDispTrace), 20]"
      />
      <!-- Tiltmeter -->
      <div v-if="this.getTiltTrace && this.getSensorType === 'tiltmeter'">
        <div class="double-small-graphs">
          <div class="small-graph">
            <LinePlot
              v-if="getSelectedSensor && getSensorType === 'tiltmeter'"
              :height="this.plotHeight"
              :traces="this.getTiltTraceSub1"
              xTitle="Time (Hr)"
              :yTitle="'Δφ ' + $t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
            />
          </div>
          <div class="small-graph">
            <LinePlot
              v-if="getSelectedSensor && getSensorType === 'tiltmeter'"
              :height="this.plotHeight"
              :traces="this.getTiltTraceSub2"
              xTitle="Time (Hr)"
              :yTitle="'Δϑ ' + $t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
            />
          </div>
        </div>
        <div class="horiz-divider"></div>
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{$t("message.tilt3dGraph")}}</h2>
          <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
        </div>
        <LinePlot
          v-if="this.getTiltTrace && this.getSensorType === 'tiltmeter'"
          :height="this.plotHeight"
          :traces="this.getTiltTrace"
          :yTitle="$t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
          xTitle="Time (Date)"
        />
      </div>
      <!-- Crackmeter -->
      <LinePlot
        v-if="this.getCrackTrace && this.getSensorType === 'crackmeter' && !this.getSelectedSensor.subType"
        :height="this.plotHeight"
        :traces="this.getCrackTrace"
        :yTitle="this.$t('dataType.crack') + ' (mm)'"
        xTitle="Time (Date)"
      />
      <!-- Nodo -->
      <div v-if="this.getSelectedSensor && (this.getSensorType === 'analog-node' || this.getSensorType === 'digital-node')">
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{ 'Analog Node' }}</h2>
          <p class="first-block">{{ 'Analog Node Data'}}</p>
        </div>
        <div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH1Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[0].name + ' [' + (getSelectedSensor.userConfig.channels[0].mesUnit || ' - ')  + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH2Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[1].name + ' [' + (getSelectedSensor.userConfig.channels[1].mesUnit || ' - ')  + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH3Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[2].name + ' [' + (getSelectedSensor.userConfig.channels[2].mesUnit || ' - ')  + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH4Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[3].name + ' [' + (getSelectedSensor.userConfig.channels[3].mesUnit || ' - ')  + ']'" />
          </div>
        </div>
      </div>
      <!-- loadcell -->
      <LinePlot
        v-if="this.getCrackTrace && this.getSensorType === 'crackmeter' && this.getSelectedSensor.subType === 'loadcell'"
        :height="this.plotHeight"
        :traces="this.getLoadTrace"
        :yTitle="'Load (N)'"
        xTitle="Time (Date)"
      />
      <!-- Accelerometer (3 Plots)-->
      <div class="acc-plot-wrapper" v-if="this.getDispDetails && this.getSensorType === 'accelerometer'">
        <LinePlot
          :height="this.plotHeight"
          :traces="this.getAccXTrace"
          yTitle="X (mg)"
          xTitle="Time (s)"
          :yRange="[(Math.min(...this.getAccXTrace[0].y) > -1) ? -1 : null, (Math.max(...this.getAccXTrace[0].y) < 1) ? 1 : null]"
        />
      </div>
      <div class="acc-plot-wrapper" v-if="this.getDispDetails && this.getSensorType === 'accelerometer'">
        <LinePlot
          :height="this.plotHeight"
          :traces="this.getAccYTrace"
          yTitle="Y (mg)"
          xTitle="Time (s)"
          :yRange="[(Math.min(...this.getAccYTrace[0].y) > -1) ? -1 : null, (Math.max(...this.getAccYTrace[0].y) < 1) ? 1 : null]"
        />
      </div>
      <div class="acc-plot-wrapper" v-if="this.getDispDetails && this.getSensorType === 'accelerometer'">
        <LinePlot
          :height="this.plotHeight"
          :traces="this.getAccZTrace"
          yTitle="Z (mg)"
          xTitle="Time (s)"
          :yRange="[(Math.min(...this.getAccZTrace[0].y) > -1) ? -1 : null, (Math.max(...this.getAccZTrace[0].y) < 1) ? 1 : null]"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LinePlot from '../../graphs/LinePlot.vue'
import ModalVideoTutorial from '../../ui/ModalVideoTutorial'
import { mapGetters, mapActions } from 'vuex'
import download from '../../../helpers/download.js'
import math from '../../../helpers/math.js'

var mql = window.matchMedia('screen and (max-width: 1499px)')

export default {
  name: 'event-module',
  components: {
    LinePlot,
    ModalVideoTutorial
  },
  data() {
    return {
      loaded: false,
      firstExec: true,
      xRange: null,
      showVideoTutorial: false,
      today: new Date(Date.now()).toLocaleString().split(',')[0],
      plotHeight: 490,
      baseTrace: {
        connectgaps: true,
        /* Trace di base a cui vengono aggiunti attributi in base al grafico */
        line: {
          color: 'rgb(17, 205, 239)',
          width: 4,
        },
        marker: {
          color: 'rgb(255, 255, 255)',
          size: 4,
        },
        name: 'Peaks Line',
        type: 'scatter',
        xaxis: 'x',
        yaxis: 'y',
        opacity: 0.9,
        textfont: {},
      },
    }
  },
  methods: {
    ...mapActions({
      setDateRange: 'eventdetails/setDateRange',
      setSelectedSensor: 'eventdetails/setSelectedSensor',
      fetchDispDetails: 'eventdetails/fetchDispDetails',
      setAbsolute3dAngle: 'eventdetails/setAbsolute3dAngle'
    }),
    getDeckSampleRate(payloadLength){
      return (payloadLength === 1600 ? 50 : 100);
    },
    sensorSelected: function (value) {
      this.setSelectedSensor(value)
    },
    dateSelected: function (dateRange) {
      this.setDateRange(dateRange)
    },
    responsiveScreenHandler: function (e) {
      // Modifico l'attributo 'height' del grafico in base alla dimensione della finestra, vedere 'mql'
      if (e.matches) {
        this.plotHeight = 350
      } else {
        this.plotHeight = 490
      }
    },
    getDisplacementBegin: function (trace) {
      let begin = trace[0].x ? trace[0].x.length / this.getDeckSampleRate(trace[0].x.length) - 20 : 0
      return -begin
    },
    downloadEventDetails: function () {
      if (this.getIsThereData && this.getLoadingStatus) {
        // Ritorna header ed eventi da passare alla funzione che crea il .CSV
        let events = []
        let headers = {}
        let title
        let devEui = this.getSelectedSensor.eui
        let smallestArray
        switch (this.getSensorType) {
          case 'deck':
            events = this.getDispDetails.payload.dati.map(function (item) {
              return {
                eui: devEui.substr(devEui.length - 4),
                amplitude: item,
              }
            })
            headers = {
              eui: 'Device',
              amplitude: 'Amplitude',
            }
            title = 'Event Deck ' + devEui.substr(devEui.length - 4)
            break
          case 'accelerometer':
            smallestArray = Math.min(
              this.getAccelerationDetails.acceleration.x.length,
              this.getAccelerationDetails.acceleration.y.length,
              this.getAccelerationDetails.acceleration.z.length
            )
            for (let i = 0; i < smallestArray; i++) {
              events.push({
                eui: devEui.substr(devEui.length - 4),
                xAmplitude: this.getAccelerationDetails.acceleration.x[i],
                yAmplitude: this.getAccelerationDetails.acceleration.y[i],
                zAmplitude: this.getAccelerationDetails.acceleration.z[i],
              })
            }
            headers = {
              eui: 'Device',
              accX: 'X Acc (mg)',
              accY: 'Y Acc (mg)',
              accZ: 'Z Acc (mg)',
            }
            title = 'Event Accelerometer ' + devEui.substr(devEui.length - 4)
            break
        }
        download.exportCSVFile(
          // Scarica Eventi del device (no temperature)
          headers,
          events,
          title
        )
      }
    },
  },
  computed: {
    ...mapGetters({
      getSensorType: 'eventdetails/getSensorType',
      getDispDetails: 'eventdetails/getDisplacementDetails',
      getDispList: 'eventdetails/getDisplacementList',
      getSelectedSensor: 'eventdetails/getSelectedSensor',
      getDateRange: 'eventdetails/getDateRange',
      getSensors: 'structure/getSensors',
      loading: 'eventdetails/getLoadingStatus',
      getTempLoaded: 'eventdetails/getTempLoaded',
      getDispLoaded: 'eventdetails/getDispLoaded',
      getCracks: 'eventdetails/getCracks',
      getAccelerations: 'eventdetails/getAccelerations',
      getAnalogReadings: 'eventdetails/getAnalogReadings',
      getAccelerationDetails: 'eventdetails/getAccelerationDetails',
      getTilts: 'eventdetails/getTilts',
      getBaseValue: 'eventdetails/getBaseValue',
      getRelativeMode: 'eventdetails/getRelativeMode',
      getLoadingStatus: 'eventdetails/getLoadingStatus',
      getTemperaturesList: 'eventdetails/getTemperaturesList',
      getIsThereData: 'eventdetails/getIsThereData',
      getUserInterface: 'user/getInterface'
    }),
    mesUnit(){
      return this.getUserInterface ? this.getUserInterface.dimensions : null;
    },
    getAnNodeCH1Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.x = this.getAnalogReadings.map(event => new Date(event.date))
      basicTrace.y = this.getAnalogReadings.map(event => event.channelsData[0])
      return [basicTrace]
    },
    getAnNodeCH2Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.x = this.getAnalogReadings.map(event => new Date(event.date))
      basicTrace.y = this.getAnalogReadings.map(event => event.channelsData[1])
      return [basicTrace]
    },
    getAnNodeCH3Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.x = this.getAnalogReadings.map(event => new Date(event.date))
      basicTrace.y = this.getAnalogReadings.map(event => event.channelsData[2])
      return [basicTrace]
    },
    getAnNodeCH4Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.x = this.getAnalogReadings.map(event => new Date(event.date))
      basicTrace.y = this.getAnalogReadings.map(event => event.channelsData[3])
      return [basicTrace]
    },
    getTiltTrace: function () {
      // Ritorna la trace relativa all'Inclinometro
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      if (this.getTilts.length > 0) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => (this.mesUnit && this.mesUnit.degrees === 'mm/m') ? math.degreesToMM(a.extraAngle).toFixed(6) : a.extraAngle.tilt.toFixed(6))      
        //basicTrace.text = this.getTilts.map((a) => ("Versor: [" + a.extraAngle.versor[0].toFixed(4)).toString() + ', ' + (a.extraAngle.versor[1].toFixed(4)).toString() + ', ' +  (a.extraAngle.versor[2].toFixed(4)).toString() + "]")
        basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.extraAngle).toFixed(6) : a.extraAngle.toFixed(6))
      } else {
        basicTrace.x = []
        basicTrace.y = []
      }
      return [basicTrace]
    },
    getTiltTraceSub1: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      if (this.getTilts) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => (this.mesUnit && this.mesUnit.degrees === 'mm/m') ? math.degreesToMM(a.phiAngle).toFixed(6) : a.phiAngle.toFixed(6))      
        basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.phiAngle).toFixed(6) : a.phiAngle.toFixed(6))
      } else {
        basicTrace.x = []
        basicTrace.y = []
      }
      return [basicTrace]
    },
    getTiltTraceSub2: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      if (this.getTilts) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => (this.mesUnit && this.mesUnit.degrees === 'mm/m') ? math.degreesToMM(a.thetaAngle).toFixed(6) : a.thetaAngle.toFixed(6))
        basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.thetaAngle).toFixed(6) : a.thetaAngle.toFixed(6))
      } else {
        basicTrace.x = []
        basicTrace.y = []
      }
      return [basicTrace]
    },
    getCrackTrace: function () {
      // Ritorna la trace relativa all'Estensimetro
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      let offset =
        this.getRelativeMode && this.getBaseValue ? this.getBaseValue : 0
      if (this.getCracks.length > 0) {
        basicTrace.x = this.getCracks.map((a) => new Date(a.date))
        basicTrace.y = this.getCracks.map((a) => a.sample - offset)
      } else {
        basicTrace.x = []
        basicTrace.y = []
      }
      return [basicTrace]
    },
    getLoadTrace: function () {
      // Ritorna la trace relativa all'Estensimetro
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      if (this.getCracks.length > 0) {
        basicTrace.x = this.getCracks.map((a) => new Date(a.date))
        basicTrace.y = this.getCracks.map(
          (a) => (a.sample / (3.92 * Math.pow(10, -3)) - 6400) * 11.71875
        )
      } else {
        basicTrace.x = []
        basicTrace.y = []
      }
      return [basicTrace]
    },
    getDispTrace: function () {
      // Ritorna la trace relativa all Deck
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      if (this.getDispDetails.payload) {
        let sampleRate = this.getDeckSampleRate(this.getDispDetails.payload.dati.length);
        if (this.getSensorType === 'deck') {
          let begin = -(this.getDispDetails.payload.dati ? this.getDispDetails.payload.dati.length / sampleRate - 20 : 0)
          basicTrace.y = this.getDispDetails.payload.dati
          basicTrace.x = this.getDispDetails.payload.dati.map(
            (val, ind) => ind / sampleRate + begin
          )
        }
      }
      return [basicTrace]
    },
    getAxixAccelerations: function () {
      // Restituisce un oggetto contente 4 array relativi alle date ed alle accelerazioni rispettive sui 3 assi
      return {
        x: this.getAccelerationDetails.acceleration
          ? this.getAccelerationDetails.acceleration.x.map((a) => a * 1000)
          : [],
        y: this.getAccelerationDetails.acceleration
          ? this.getAccelerationDetails.acceleration.y.map((a) => a * 1000)
          : [],
        z: this.getAccelerationDetails.acceleration
          ? this.getAccelerationDetails.acceleration.z.map((a) => a * 1000)
          : [],
      }
    },
    getAccXTrace: function () {
      // Restituisce la trace relativa alle accelerazione sull'asse X

      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.y = this.getAxixAccelerations.x || []
      basicTrace.x = this.getAxixAccelerations.x.map(
        (val, ind) => (ind * 20) / 1000
      )
      return [basicTrace]
    },
    getAccYTrace: function () {
      // Restituisce la trace relativa alle accelerazione sull'asse Y
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.y = this.getAxixAccelerations.y || []
      basicTrace.x = this.getAxixAccelerations.y.map(
        (val, ind) => (ind * 20) / 1000
      )
      return [basicTrace]
    },
    getAccZTrace: function () {
      // Restituisce la trace relativa alle accelerazione sull'asse Z
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace))
      basicTrace.y = this.getAxixAccelerations.z || []
      basicTrace.x = this.getAxixAccelerations.z.map(
        (val, ind) => (ind * 20) / 1000
      )
      return [basicTrace]
    },
  },
  async mounted() {
    // Verifico la dimensione della finestra e aggiungo listener per gestire il ridimensionamento
    this.responsiveScreenHandler(mql)
    mql.addListener(this.responsiveScreenHandler)
    // Se il cliente vuole l'angolo non in valore assoluto 
    if (this.getUserInterface && this.getUserInterface.absolute3dAngle === false){
      this.setAbsolute3dAngle(false);
    }
  },
}
</script>
<style scoped>
/* Module Wrapper */
.over {
  width: 100%;
  min-width: 600px;
  column-gap: 2%;
  display: grid;
  grid-template-columns: 49% 49%;
  z-index: 2;
}
/* Divisori */
.horiz-divider {
  height: 2px;
  background-color: rgba(80, 84, 105, 1);
  margin: auto;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 90%;
}

/* Inner Wrapper */
.details-wrapper {
  position: relative;
  margin-top: 30px;
  height: fit-content;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
.double-small-graphs {
  display: grid;
  grid-template-columns: 5fr 5fr;
  column-gap: 40px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  margin-bottom: 20px;
}

.large {
  height: 1600px;
}

.download-btn {
  cursor: pointer;
  grid-row: 1/3;
  height: 18px;
  justify-self: end;
  margin-right: 32px;
  background-color: rgb(33, 150, 243);
  padding: 10px;
  grid-column: 2;
  border-radius: 10px;
}

.acc-plot-wrapper {
  min-height: 350px;
}
/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .large {
    height: 1130px;
  }
}

#temps {
  width: 100%;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}

#tx-trend {
  grid-row: 1;
  grid-column: 1;
}

#temp-trend {
  grid-row: 1;
  grid-column: 2;
}

.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}
.infoi {
  z-index: 1;
  background-color: black;
  opacity: 0.7;
  border-radius: 10px;
}
.infoi > h2 {
  margin: auto;
}
.info-svg {
  cursor: pointer;
  grid-column: 2;
  grid-row: 1;
  margin-left: -20px;
}
.main-wrap {
  margin-top: 20px;
  display: grid;
  margin-left: 60px;
  grid-template-columns: max-content;
}
.over-info > h2 {
  font-size: 1em;
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info > p {
  font-size: 0.8em;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info {
  text-align: left;
  position: relative;
}
</style>
